import './LoadingState.css';
import Skeleton, { SkeletonTable, SkeletonList, SkeletonCard } from './Skeleton';
import { IndeterminateProgressBar } from './ProgressBar';

interface LoadingStateProps {
  type?: 'skeleton' | 'spinner' | 'progress' | 'table' | 'list' | 'card';
  message?: string;
  progress?: number;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export default function LoadingState({
  type = 'skeleton',
  message,
  progress,
  size = 'medium',
  className = '',
}: LoadingStateProps) {
  if (type === 'progress') {
    return (
      <div className={`loading-state loading-state-${size} ${className}`}>
        {message && <p className="loading-state-message">{message}</p>}
        {progress !== undefined ? (
          <IndeterminateProgressBar variant="primary" size={size} />
        ) : (
          <IndeterminateProgressBar variant="primary" size={size} />
        )}
      </div>
    );
  }

  if (type === 'spinner') {
    return (
      <div className={`loading-state loading-state-spinner loading-state-${size} ${className}`}>
        <div className="spinner" />
        {message && <p className="loading-state-message">{message}</p>}
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className={`loading-state ${className}`}>
        {message && <p className="loading-state-message">{message}</p>}
        <SkeletonTable rows={5} columns={4} />
      </div>
    );
  }

  if (type === 'list') {
    return (
      <div className={`loading-state ${className}`}>
        {message && <p className="loading-state-message">{message}</p>}
        <SkeletonList items={5} />
      </div>
    );
  }

  if (type === 'card') {
    return (
      <div className={`loading-state ${className}`}>
        {message && <p className="loading-state-message">{message}</p>}
        <SkeletonCard />
      </div>
    );
  }

  // Default: skeleton
  return (
    <div className={`loading-state loading-state-${size} ${className}`}>
      {message && <p className="loading-state-message">{message}</p>}
      <Skeleton height="60px" variant="rounded" />
    </div>
  );
}

